import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { BaseApi, BASE_URL } from '@edl-development/edl-common';
import { AnecdotalObservationModel } from 'src/app/model/observation/anecdotal-observation.model';
import { CreateObservationDTO } from 'src/app/model/observation/diff/diff-create-dto.model';
import { ObservationSummaryDTO } from 'src/app/model/observation/observation-summary-dto.model';

@Injectable()
export class AnecdotalApi extends BaseApi {

    constructor(
        @Inject(BASE_URL) private baseUri: string,
        private http: HttpClient
    ) {
        super();
    }

    getObservationDetails(userId: string, observationId: string) {
        return this.http.get<AnecdotalObservationModel>(this.baseUri + '/observation/anecdotal/' + observationId, {});
    }

    createAnecdotal(observation: CreateObservationDTO) {
        return this.http.post<ObservationSummaryDTO>(this.baseUri + '/observation/anecdotal/create', observation);
    }

    deleteAnecdotal(userId: string, observationId: string) {
        return this.http.put(this.baseUri + '/observation/anecdotal/delete/' + observationId, {});
    }

    reinstateAnecdotal(userId: string, observationId: string) {
        return this.http.put(this.baseUri + '/observation/anecdotal/reinstate/' + observationId, {});
    }

    submitAnecdotal(observationId: string) {
        return this.http.put(this.baseUri + '/observation/anecdotal/' + observationId + '/submit', {});
    }
}
